import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { Box, Button, Link } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import Attachment from "../../../../../Components/Broker/Attachment/Attachment";
import SpocContact from "../../../../../Components/Broker/SpocContact/SpocContact";
import BulkUploadForm from "../../../../../Components/Common/BulkUploadFormSP/BulkUploadForm";
import RKTextField from "../../../../../Supporting files/RKTextField/RKTextField";
import SearchDropdown from "../../../../../Supporting files/SearchDropdown/SearchDropdown";
import SelectDropdown from "../../../../../Supporting files/SelectDropdown/SelectDropdown";
import UGEmailInput from "../../../../../Supporting files/UGEmailInput/UGEmailInput";
import "../AddNewClient/AddNewClient.scss";

function AddNewClient() {
  const navigate = useNavigate();
  const [organization, setOrganization] = React.useState("");
  const [ownership, setOwnership] = React.useState("");
  const [industry, setIndustry] = React.useState("");
  const [subindustry, setSubIndustry] = React.useState("");
  const [organizationEmail, setOrganizationEmail] = React.useState("");
  const [organizationPhone, setOrganizationPhone] = React.useState("");
  const [taxId, setTaxId] = React.useState("");
  const [companyId, setCompanyId] = React.useState("");
  const [websiteUrl, setWebsiteUrl] = React.useState("");
  const [domainCompany, setDomainCompany] = React.useState("");
  const [locationName, setLocationName] = React.useState("");
  const [locationType, setLocationType] = React.useState("");
  const [buildingName, setBuildingName] = React.useState("");
  const [areaName, setAreaName] = React.useState("");
  const [country, setCountry] = React.useState("");
  const [pincode, setPinCode] = React.useState("");
  const [state, setState] = React.useState("");
  const [city, setCity] = React.useState("");
  const [selectSpoc, setSelectSpoc] = React.useState("");
  const [exchangeRate, setExchangeRate] = React.useState(true);
  const [employer, setEmployer] = React.useState(true);
  const [toggle, setToggle] = React.useState(true);
  const [sectionStatus, SetSectionStatus] = React.useState<string>(
    "personalDetailsSection"
  );
  const [officelocationname, setOfficeLocationName] = React.useState("");
  const [officelocationtype, setOfficeLocationType] = React.useState("");
  const [officestreetname, setOfficeStreetName] = React.useState("");
  const [Officeareaname, setOfficeAreaName] = React.useState("");
  const [officecountry, setOfficeCountry] = React.useState("");
  const [officepincode, setOfficePinCode] = React.useState("");
  const [officestate, setOfficeState] = React.useState("");
  const [officecity, setOfficeCity] = React.useState("");
  const [officeselectspoc, setOfficeSelectSpoc] = React.useState("");

  const [subSection, setSubSection] = React.useState<string>("basics");
  const [uploadFile, setUploadFile] = React.useState(false);
  const [attachment, setAttachment] = React.useState(false);
  const [removeEmployee, setRemoveEmployee] = React.useState(false);
  const [deleteStatus, setDeleteStatus] = React.useState(false);
  const [file, setFile] = React.useState("");

  const ownership_data = [
    { key: "Ownership", value: "Ownership" },
    { key: "Ownership", value: "Ownership" },
  ];
  const industry_data = [
    { label: "Engineering", value: "Engineering" },
    { label: "IT", value: "IT" },
    { label: "Human Resource", value: "Human Resource" },
    { label: "Business Development", value: "Business Development" },
    { label: "Designing", value: "Designing" },
    { label: "Management", value: "Management" },
  ];
  const subindustry_data = [
    { label: "Engineering", value: "Engineering" },
    { label: "IT", value: "IT" },
    { label: "Human Resource", value: "Human Resource" },
    { label: "Business Development", value: "Business Development" },
    { label: "Designing", value: "Designing" },
    { label: "Management", value: "Management" },
  ];
  const country_data = [
    { label: "India", value: "India" },
    { label: "Australia", value: "Australia" },
    { label: "New Zealand", value: "New Zealand" },
    { label: "England", value: "England" },
    { label: "South Africa", value: "South Africa" },
    { label: "Sri Lanka", value: "Sri Lanka" },
  ];
  const state_data = [
    { label: "Uttarakhand", value: "Uttarakhand" },
    { label: "Haryana", value: "Haryana" },
    { label: "Uttar Pradesh", value: "Uttar Pradesh" },
    { label: "Himachal", value: "Himachal" },
    { label: "Punjab", value: "Punjab" },
    { label: "Rajasthan", value: "Rajasthan" },
  ];
  const city_data = [
    { label: "Dehradun", value: "Dehradun" },
    { label: "Haridwar", value: "Haridwar" },
    { label: "Ambala", value: "Ambala" },
    { label: "Gurugram", value: "Gurugram" },
    { label: "Noida", value: "Noida" },
    { label: "Chandigarh", value: "Chandigarh" },
  ];
  const spoc_data = [
    {
      label: "EV1012152 - Kartike Kakkar-Evervent",
      value: "EV1012152 - Kartike Kakkar-Evervent",
    },
    {
      label: "EV1252524 - Vikas Saini-TCS",
      value: "EV1252524 - Vikas Saini-TCS",
    },
    {
      label: "EV1241421 - Rahul Raghuvanshi-Google",
      value: "EV1241421 - Rahul Raghuvanshi-Google",
    },
    {
      label: "EV1241423 - Rohit Manokotia-Meta",
      value: "EV1241423 - Rohit Manokotia-Meta",
    },
    {
      label: "EV1241422 - Udit Jaswal-Linked In",
      value: "EV1241422 - Udit Jaswal-Linked In",
    },
  ];

  const [addressData, setAddressData] = React.useState<
    Array<{
      title: string;
      location_name: string;
      location_type: string;
      street_name: string;
      area_name: string;
      country: string;
      pin_code: string;
      state: string;
      city: string;
      spoc_title: string;
      select_spoc: string;
      delete: boolean;
    }>
  >([
    {
      title: "Registered Address Details",
      location_name: "",
      location_type: "",
      street_name: "",
      area_name: "",
      country: "",
      pin_code: "",
      state: "",
      city: "",
      spoc_title: "",
      select_spoc: "",
      delete: false,
    },
  ]);

  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);
  };
  const handleClick = () => {
    setToggle(true);
  };

  // for scrolling

  const organizationDetailsSection = useRef(null);
  const attatchmentsSection = useRef(null);
  const settingSection = useRef(null);
  const basics = useRef(null);
  const registeredAddress = useRef(null);
  const spoc = useRef(null);

  const scrollToSection = (elementRef: any) => {
    // debugger;
    elementRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleClicks = (ref: any) => {
    console.log("handle click", ref);
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  function handleChange(e: any) {
    console.log(e.target.files);
    setFile(URL.createObjectURL(e.target.files[0]));
  }

  return (
    <Box className="layoutWrapper">
      <BulkUploadForm
        open_status={uploadFile}
        attrName={setUploadFile}
        value_update={updateMasterState}
      />

      {/* Page header */}
      <Grid container spacing={3} className="pageHeader">
        <Grid xs={6} className="pageTitle">
          <Link
            className="backStep"
            onClick={() => {
              navigate("/homebroker?page=clients");
            }}
          >
            <ChevronLeftIcon />
          </Link>

          <div>
            <h3> Add New Client</h3>
          </div>
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid xs={12}>
          <Grid container spacing={3}>
            <Grid xs className="leftSection">
              <Link
                className={
                  sectionStatus === "organizationDetailsSection"
                    ? "active sectionLink organizationDetailsSection"
                    : "sectionLink organizationDetailsSection"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(organizationDetailsSection);
                  SetSectionStatus("organizationDetailsSection");
                }}
              >
                <span>Organization Details </span>
              </Link>
              <ul className="accordion_list">
                <li>
                  <Link
                    className={
                      subSection === "basics"
                        ? "inner_link active basics"
                        : "inner_link  basics"
                    }
                    onClick={() => {
                      handleClicks(subSection);
                      scrollToSection(basics);
                      setSubSection("basics");
                    }}
                  >
                    Basic Info
                  </Link>
                </li>
                <li>
                  <Link
                    className={
                      subSection === "registeredAddress"
                        ? "inner_link active"
                        : "inner_link registeredAddress"
                    }
                    onClick={() => {
                      handleClicks(subSection);
                      scrollToSection(registeredAddress);
                      setSubSection("registeredAddress");
                    }}
                  >
                    Registered Address
                  </Link>
                </li>
                <li>
                  <Link
                    className={
                      subSection === "spoc"
                        ? "inner_link active"
                        : "inner_link spoc"
                    }
                    onClick={() => {
                      handleClicks(subSection);
                      scrollToSection(spoc);
                      setSubSection("spoc");
                    }}
                  >
                    SPOC
                  </Link>
                </li>
              </ul>
              <Link
                className={
                  sectionStatus === "attatchmentsSection"
                    ? "active sectionLink attatchmentsSection"
                    : "sectionLink attatchmentsSection"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(attatchmentsSection);
                  SetSectionStatus("attatchmentsSection");
                }}
              >
                <span> Attatchment</span>
              </Link>
              {/* <Link
                className={
                  sectionStatus === "settingSection"
                    ? "active sectionLink settingSection"
                    : "sectionLink settingSection"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(settingSection);
                  SetSectionStatus("settingSection");
                }}
              >
                <span> Settings</span>
              </Link> */}
            </Grid>
            <Grid xs className="rightSection">
              <Box className="upload-logo">
                <Grid container sx={{ paddingLeft: 0 }} className="mb-3">
                  <Grid xs={12}>
                    <img
                      src={
                        file.length > 0 ? file : "images/preview-logo-img.svg"
                      }
                      alt=""
                      className="upload_company_logo"
                    />
                    <Link className="upload_img" component="label">
                      <input
                        hidden
                        accept="image/*"
                        multiple
                        type="file"
                        onChange={handleChange}
                      />

                      <img src="images/upload_logo_icon.svg" alt="" />
                      <span>Add logo</span>
                    </Link>
                  </Grid>
                </Grid>
              </Box>
              <Box className="detailSection" ref={organizationDetailsSection}>
                <div className="sectionTitle">
                  <h4>Organization Details</h4>
                </div>
                <div ref={basics}>
                  <Grid container spacing={3}>
                    <Grid xs={12}>
                      <h5 className="subHeading">Basic Info</h5>
                    </Grid>
                  </Grid>
                  <Grid container spacing={3}>
                    <Grid xs={6}>
                      <RKTextField
                        class_name="inputField"
                        title="Organization"
                        value={organization}
                        attrName={setOrganization}
                        value_update={updateMasterState}
                        warn_status={false}
                      />
                    </Grid>
                    <Grid xs={6}>
                      <SelectDropdown
                        class_name="inputField"
                        title="Ownership"
                        value={ownership}
                        attrName={setOwnership}
                        value_update={updateMasterState}
                        dropdown_data={ownership_data}
                        warn_status={false}
                      />
                    </Grid>
                    <Grid xs={4}>
                      <SearchDropdown
                        class_name="inputField"
                        title="Industry"
                        value={industry}
                        attrName={setIndustry}
                        value_update={updateMasterState}
                        data={industry_data}
                        warn_status={false}
                        error_message="Please select client"
                      />
                    </Grid>
                    <Grid xs={4}>
                      <SearchDropdown
                        class_name="inputField"
                        title="Sub-Industry"
                        value={subindustry}
                        attrName={setSubIndustry}
                        value_update={updateMasterState}
                        data={subindustry_data}
                        warn_status={false}
                        error_message="Please select client"
                      />
                    </Grid>
                    <Grid xs={4}>
                      <RKTextField
                        class_name="inputField"
                        title="Organization Email"
                        value={organizationEmail}
                        attrName={setOrganizationEmail}
                        value_update={updateMasterState}
                        warn_status={false}
                      />
                    </Grid>
                    <Grid xs={4}>
                      <RKTextField
                        class_name="inputField"
                        title="Organization Phone Number"
                        value={organizationPhone}
                        attrName={setOrganizationPhone}
                        value_update={updateMasterState}
                        warn_status={false}
                      />
                    </Grid>
                    <Grid xs={4}>
                      <RKTextField
                        class_name="inputField"
                        title="Tax ID"
                        value={taxId}
                        attrName={setTaxId}
                        value_update={updateMasterState}
                        warn_status={false}
                      />
                    </Grid>
                    <Grid xs={4}>
                      <RKTextField
                        class_name="inputField"
                        title="Company ID"
                        value={companyId}
                        attrName={setCompanyId}
                        value_update={updateMasterState}
                        warn_status={false}
                      />
                    </Grid>
                    <Grid xs={4}>
                      <RKTextField
                        class_name="inputField"
                        title="Website URL"
                        value={websiteUrl}
                        attrName={setWebsiteUrl}
                        value_update={updateMasterState}
                        warn_status={false}
                      />
                    </Grid>
                    <Grid xs={8}>
                      <UGEmailInput
                        class_name="inputField"
                        title="Domain"
                        value={domainCompany}
                        attrName={setDomainCompany}
                        value_update={updateMasterState}
                        warn_status={false}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={3}>
                    <Grid xs={12}>
                      <h5 className="subHeading">Registered Address Details</h5>
                    </Grid>
                  </Grid>
                  <Grid container spacing={3}>
                    <Grid sm={6} md={6} lg={6} xl={6}>
                      <RKTextField
                        class_name="inputField"
                        title="Location Name"
                        value={officelocationname}
                        attrName={setOfficeLocationName}
                        value_update={updateMasterState}
                        warn_status={false}
                      />
                    </Grid>
                    <Grid sm={6} md={6} lg={6} xl={6}>
                      <RKTextField
                        class_name="inputField"
                        title="Location Type"
                        value={officelocationtype}
                        attrName={setOfficeLocationType}
                        value_update={updateMasterState}
                        warn_status={false}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={3}>
                    <Grid sm={6} md={6} lg={6} xl={6}>
                      <RKTextField
                        class_name="inputField"
                        title="Building/Street Name"
                        value={officestreetname}
                        attrName={setOfficeStreetName}
                        value_update={updateMasterState}
                        warn_status={false}
                      />
                    </Grid>
                    <Grid sm={6} md={6} lg={6} xl={6}>
                      <RKTextField
                        class_name="inputField"
                        title="Area Name"
                        value={Officeareaname}
                        attrName={setOfficeAreaName}
                        value_update={updateMasterState}
                        warn_status={false}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={3}>
                    <Grid sm={6} md={4} lg={3} xl={3}>
                      <SearchDropdown
                        class_name="inputField"
                        title="Country"
                        value={officecountry}
                        attrName={setOfficeCountry}
                        value_update={updateMasterState}
                        data={country_data}
                        error_message="Please select country"
                        warn_status={false}
                      />
                    </Grid>
                    <Grid sm={6} md={4} lg={3} xl={3}>
                      <RKTextField
                        class_name="inputField"
                        title={"Pincode"}
                        value={officepincode}
                        attrName={setOfficePinCode}
                        value_update={updateMasterState}
                        warn_status={false}
                      />
                    </Grid>
                    <Grid sm={6} md={4} lg={3} xl={3}>
                      <SearchDropdown
                        class_name="inputField"
                        title="State"
                        value={officestate}
                        attrName={setOfficeState}
                        value_update={updateMasterState}
                        data={state_data}
                        error_message="Please select state"
                        warn_status={false}
                      />
                    </Grid>
                    <Grid sm={6} md={4} lg={3} xl={3}>
                      <SearchDropdown
                        class_name="inputField"
                        title="City"
                        value={officecity}
                        attrName={setOfficeCity}
                        value_update={updateMasterState}
                        data={city_data}
                        error_message="Please select city"
                        warn_status={false}
                      />
                    </Grid>
                  </Grid>
                  <div>
                    <SpocContact />
                  </div>
                </div>
              </Box>

              {/* locations section comment */}

              {/* <Box className="detailSection">
                <div className="sectionTitle">
                  <h4>Locations </h4>
                  <div className="actionBtns">
                    <Link
                      className="blueBtn addfile"
                      sx={{ textDecoration: "none", cursor: "pointer" }}
                      onClick={() => {
                        setAddressData([
                          ...addressData,
                          {
                            title: "Locations",
                            location_name: "",
                            location_type: "",
                            street_name: "",
                            area_name: "",
                            country: "",
                            pin_code: "",
                            state: "",
                            city: "",
                            spoc_title: "",
                            select_spoc: "",
                            delete: true,
                          },
                        ]);
                      }}
                    >
                      Add Locations
                    </Link>
                  </div>
                </div>
                
                {addressData.map((data, index) => (
                  <Grid container spacing={3} className="">
                    <Grid xs={6}>
                      {index === 0 ? null : (
                        <h5 className="subHeading">
                          {data.title + " "}
                          {index}
                        </h5>
                      )}
                    </Grid>
                    <Grid xs={6} sx={{ textAlign: "right" }}>
                     

                      {index === 0 ? null : (
                        <Link
                          
                          className="redBtn delete ml-0"
                          underline="none"
                          onClick={() => {
                            setAddressData(
                              addressData.filter((_, i) => i !== index)
                            );
                          }}
                        >
                          Delete Location
                        </Link>
                      )}

                     
                    </Grid>

                    {index === 0 ? (
                      <></>
                    ) : (
                      <Grid xs={12}>
                        <Grid container spacing={3}>
                          <Grid sm={6} md={6} lg={6} xl={6}>
                            <RKTextField
                              class_name="inputField"
                              title="Location Name"
                              value={data.location_name}
                              attrName={[index, "location_name"]}
                              value_update={updateMasterState}
                              warn_status={false}
                            />
                          </Grid>
                          <Grid sm={6} md={6} lg={6} xl={6}>
                            <RKTextField
                              class_name="inputField"
                              title="Location Type"
                              value={data.location_type}
                              attrName={[index, "location_type"]}
                              value_update={updateMasterState}
                              warn_status={false}
                            />
                          </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                          <Grid sm={6} md={6} lg={6} xl={6}>
                            <RKTextField
                              class_name="inputField"
                              title="Building/Street Name"
                              value={data.street_name}
                              attrName={[index, "street_name"]}
                              value_update={updateMasterState}
                              warn_status={false}
                            />
                          </Grid>
                          <Grid sm={6} md={6} lg={6} xl={6}>
                            <RKTextField
                              class_name="inputField"
                              title="Area Name"
                              value={data.area_name}
                              attrName={[index, "area_name"]}
                              value_update={updateMasterState}
                              warn_status={false}
                            />
                          </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                          <Grid sm={6} md={4} lg={3} xl={3}>
                            <SearchDropdown
                              class_name="inputField"
                              title="Country"
                              value={data.country}
                              attrName={[index, "country"]}
                              value_update={updateMasterState}
                              data={country_data}
                              error_message="Please select country"
                              warn_status={false}
                            />
                          </Grid>
                          <Grid sm={6} md={4} lg={3} xl={3}>
                            <RKTextField
                              class_name="inputField"
                              title={"Pincode"}
                              value={data.pin_code}
                              attrName={[index, "pin_code"]}
                              value_update={updateMasterState}
                              warn_status={false}
                            />
                          </Grid>
                          <Grid sm={6} md={4} lg={3} xl={3}>
                            <SearchDropdown
                              class_name="inputField"
                              title="State"
                              value={data.state}
                              attrName={[index, "state"]}
                              value_update={updateMasterState}
                              data={state_data}
                              error_message="Please select state"
                              warn_status={false}
                            />
                          </Grid>
                          <Grid sm={6} md={4} lg={3} xl={3}>
                            <SearchDropdown
                              class_name="inputField"
                              title="City"
                              value={data.city}
                              attrName={[index, "city"]}
                              value_update={updateMasterState}
                              data={city_data}
                              error_message="Please select city"
                              warn_status={false}
                            />
                          </Grid>
                          <div ref={spoc} style={{ width: "100%" }}>
                            <Grid container spacing={3}>
                              <Grid xs={12}>
                                <h5 className="mb-0 subHeading">SPOC Info</h5>
                              </Grid>

                              <Grid xs={4}>
                                <SearchDropdown
                                  class_name="inputField"
                                  title="Select SPOC"
                                  value={data.select_spoc}
                                  attrName={[index, "select_spoc"]}
                                  value_update={updateMasterState}
                                  data={spoc_data}
                                  error_message="Please select spoc"
                                  warn_status={false}
                                />
                              </Grid>
                              <Grid xs={4}>
                                OR
                                <Link
                                  
                                  className="greenBtn addfile mt-2 text-right"
                                  underline="none"
                                  onClick={() => {
                                    navigate("/AddNewContact");
                                  }}
                                >
                                  Create New Contact
                                </Link>
                              </Grid>
                            </Grid>
                          </div>
                        </Grid>
                      </Grid>
                    )}
                  </Grid>
                ))}
                
              </Box> */}

              {/* attachment section comment */}

              {/* <Box className="detailSection" ref={attatchmentsSection}>
                <BulkUploadForm
                  open_status={uploadFile}
                  attrName={setUploadFile}
                  value_update={updateMasterState}
                />
                <div className="sectionTitle">
                  <h4>Attachments </h4>

                  <div className="actionBtns">
                    <Link
                      className="blueBtn addfile"
                      sx={{ textDecoration: "none", cursor: "pointer" }}
                      onClick={() => setUploadFile(true)}
                    >
                      Add Document
                    </Link>
                  </div>
                </div>

                <Attachment
                  open_status={attachment}
                  attrName={setAttachment}
                  value_update={updateMasterState}
                />
               
              </Box> */}

              {/* setting section commented */}

              {/* <Box className="detailSection" ref={settingSection}>
                <div className="sectionTitle">
                  <h4>Settings</h4>
                </div>

                <Grid container spacing={3} className="emp_switchFields">
                  <Grid xs={4} display={"flex"} alignItems="center">
                    <span>Enable Employee Portal</span>
                    <input
                      type="checkbox"
                      className="switch"
                      onClick={handleClick}
                    />
                  </Grid>
                  <Grid xs={4} display={"flex"} alignItems="center">
                    <span> Enable Employer Portal</span>
                    <input
                      type="checkbox"
                      className="switch"
                      onClick={handleClick}
                    />
                  </Grid>
                </Grid>
              </Box> */}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {/* Footer Section */}
      <Grid container spacing={3} className="footerSection">
        <Grid xs={12} className="ctaBtn">
          <Button variant="outlined" className="borderBtn">
            Cancel
          </Button>
          <Button variant="contained" className="submitBtn">
            Save & Continue
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}

export default AddNewClient;
